import { Config } from "@/utils/config.utils";
import { useScript } from "@/utils/hooks/useScript.hook";

export const useWoosmapScript = () => {
    const woosmapKey = Config.integrations["woosmap-key"];

    const { status: scriptStatus } = useScript({
        src: `https://sdk.woosmap.com/map/map.js?key=${woosmapKey}`,
        id: "woosmap"
    });

    return scriptStatus;
};
